import React from "react";
import { Quote } from "lucide-react";
import { testimonials } from "../mock";

export default function Testimonials() {
  return (
    <section id="temoignages" className="relative py-20 md:py-28">
      <div className="orb" style={{ width: 420, height: 420, background: "#06799b", right: -100, top: 60, opacity: 0.25 }} />
      <div className="relative mx-auto max-w-7xl px-5">
        <div className="text-center reveal max-w-3xl mx-auto">
          <span className="kicker">Ils ont transformé leur pratique</span>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-white mt-3">
            Avant / Après les{" "}
            <span className="gold-gradient-text">Maîtres Dauphins</span>
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((t) => (
            <div key={t.name} className="reveal glass card-hover rounded-3xl p-6 flex flex-col">
              <Quote className="h-6 w-6 text-gold/70" />
              <div className="mt-4 space-y-3 flex-1">
                <div>
                  <span className="text-[11px] uppercase tracking-widest text-white/40">Avant</span>
                  <p className="text-sm text-white/55 italic mt-1">« {t.before} »</p>
                </div>
                <div className="shimmer-line" />
                <div>
                  <span className="text-[11px] uppercase tracking-widest text-aqua">Après</span>
                  <p className="text-sm text-white/90 mt-1">« {t.after} »</p>
                </div>
              </div>
              <div className="mt-5 pt-4 border-t border-white/10 flex items-center gap-3">
                <span className="grid place-items-center h-9 w-9 rounded-full bg-[#e8c874]/15 text-gold font-display">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <div className="text-white text-sm font-medium">{t.name}</div>
                  <div className="text-white/45 text-xs">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
